import React from 'react';
import { useSelector } from 'react-redux';
import Text from '../../../../shared/components/features/text/Text';
import FinalProjectTimer from '../finalProjectTimer/FinalProjectTimer';
import classes from './FinalProjectHeader.module.css';

const FinalProjectHeader = ({ studentData, submissionBox }) => {

    const { texts } = useSelector(state => state.translate);
    const { projectInformation } = studentData || {};
    const projectInfoText = [
        projectInformation?.subjectName,
        projectInformation?.instructorName,
        projectInformation?.profession
    ].filter(Boolean).join(' | ');

    return (
        <div className={classes.WrappDiv}>
            <div className={classes.Header}>
                <div className={classes.ProjectInfoSection}>
                    <Text className={classes.Title}>{texts.myFinalProjects}</Text>
                    {projectInfoText &&
                        <div className={classes.ProjectInformation}>{projectInfoText}</div>
                    }
                </div>
                <div className={classes.TimerSection}>
                    <FinalProjectTimer
                        isSubmitted={studentData?.isSubmitted}
                        presentationDate={studentData?.presentationDate}
                        submissionBox={submissionBox}
                        isPopup={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default FinalProjectHeader;
